// extracted by mini-css-extract-plugin
export default {"wrapper":"Publicity_wrapper__cBK0f","pill":"Publicity_pill__ADQTB","pr-img":"Publicity_pr-img__ehNh9"};